import { CHAPTERS, PORTRAIT_IMAGE } from "../../data";
import Reveal from "./Reveal";

const About = () => (
  <section id="apropos" className="py-24 lg:py-32" data-testid="about-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <Reveal className="lg:sticky lg:top-28">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-blue-400 mb-4">Manifeste</p>
            <h2 className="font-display font-bold tracking-tight text-2xl sm:text-4xl lg:text-5xl mb-10">
              Le web comme<br /><span className="text-blue-500">terrain de jeu</span>
            </h2>
            <div className="relative rounded-2xl overflow-hidden border border-white/10 group">
              <img
                src={PORTRAIT_IMAGE}
                alt="Portrait de Merdi"
                className="w-full aspect-[4/5] object-cover transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
                data-testid="about-portrait"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#08080a]/80 via-transparent to-transparent" />
              <div className="absolute bottom-5 left-5">
                <p className="font-display font-bold text-lg">Merdi</p>
                <p className="font-mono text-xs text-zinc-400 uppercase tracking-wider">Web designer</p>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <div className="flex flex-col">
            {CHAPTERS.map((chapter, i) => (
              <Reveal key={chapter.number} delay={i * 0.1}>
                <div
                  className="border-t border-white/10 py-10 last:border-b group"
                  data-testid={`manifesto-chapter-${chapter.number}`}
                >
                  <div className="flex items-baseline gap-6">
                    <span className="font-mono text-sm text-blue-500 shrink-0">{chapter.number}</span>
                    <div>
                      <h3 className="font-display font-semibold text-2xl sm:text-3xl tracking-tight mb-4 group-hover:text-blue-400 transition-colors duration-500">
                        {chapter.title}
                      </h3>
                      <p className="text-zinc-400 leading-relaxed max-w-xl">{chapter.text}</p>
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default About;
